var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1F34034C-740A-4EE3-B72C-51FC12934FAF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-app",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "summary",
    transform: "translate(-966, -415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "red-alert",
    transform: "translate(966, 415)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6336867,3.49509232 L29.5800601,23.5634436 C30.3734483,25.0179886 29.8374748,26.8402985 28.3829298,27.6336867 C27.942264,27.8740499 27.4483304,28 26.9463734,28 L5.05362657,28 C3.39677232,28 2.05362657,26.6568542 2.05362657,25 C2.05362657,24.498043 2.17957669,24.0041094 2.41993985,23.5634436 L13.3663133,3.49509232 C14.1597015,2.04054731 15.9820114,1.5045738 17.4365564,2.29796199 C17.9422559,2.57379811 18.3578506,2.98939276 18.6336867,3.49509232 Z",
    id: "Shape",
    fill: "#F74429",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16, 17.3333) scale(1, -1) translate(-16, -17.3333)translate(14.6667, 10.6667)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33333333,13.3333333 C1.71106667,13.3333333 2.02773333,13.2056 2.28333333,12.95 C2.53893333,12.6944 2.66666667,12.3777333 2.66666667,12 L2.66666667,6.66666667 C2.66666667,6.28893333 2.53893333,5.97226667 2.28333333,5.71666667 C2.02773333,5.46106667 1.71106667,5.33333333 1.33333333,5.33333333 C0.9556,5.33333333 0.638933333,5.46106667 0.383333333,5.71666667 C0.127733333,5.97226667 0,6.28893333 0,6.66666667 L0,12 C0,12.3777333 0.127733333,12.6944 0.383333333,12.95 C0.638933333,13.2056 0.9556,13.3333333 1.33333333,13.3333333 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33333333,2.66666667 C1.71106667,2.66666667 2.02773333,2.53889333 2.28333333,2.28333333 C2.53893333,2.02777333 2.66666667,1.71110667 2.66666667,1.33333333 C2.66666667,0.95556 2.53893333,0.638893333 2.28333333,0.383333333 C2.02773333,0.127773333 1.71106667,0 1.33333333,0 C0.9556,0 0.638933333,0.127773333 0.383333333,0.383333333 C0.127733333,0.638893333 0,0.95556 0,1.33333333 C0,1.71110667 0.127733333,2.02777333 0.383333333,2.28333333 C0.638933333,2.53889333 0.9556,2.66666667 1.33333333,2.66666667 Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.f16cfa603afaa78a36a4918c7b0dda8d.svg";
export { ForwardRef as ReactComponent };